import React from 'react';
import { navigate } from './App';
import { letterLessons } from './letterLessons';
import { getProgress } from './letterProgress';
import { getStats } from './stats';

// The "almanac cover": app entry point and table of contents. Orients a
// first-time visitor and lets returning ones jump to any section. Subtle
// state hints (lessons done, current streak) tie it to the user's progress
// and quietly disappear when there's nothing to show yet.
function HomePage() {
  const completed = Object.keys(getProgress().completed).length;
  const totalLessons = letterLessons.length;
  const { streak } = getStats();

  const entries = [
    {
      key: 'letters',
      title: 'Letters',
      blurb: 'Learn the alphabet, shape by shape.',
      hint: completed > 0 ? `${completed} / ${totalLessons} lessons` : null,
      path: '/letters',
    },
    {
      key: 'words',
      title: 'Words',
      blurb: 'Practise the word quiz.',
      hint: null,
      path: '/quiz',
    },
    {
      key: 'vocab',
      title: 'Vocabulary',
      blurb: 'Match words to their meaning.',
      hint: null,
      path: '/vocab',
    },
    {
      key: 'progress',
      title: 'Progress',
      blurb: 'Your streak and stats.',
      hint: streak > 0 ? `${streak}-day streak` : null,
      path: '/stats',
    },
  ];

  return (
    <div className='screen'>
      <main className='quiz-card home-cover'>
        <div className='home-brand'>
          <span className='home-mark' lang='fa' dir='rtl'>دری</span>
          <h1 className='home-title'>Learn Dari</h1>
          <p className='home-tagline'>A quiet primer for reading and remembering.</p>
        </div>
        <div className='rule-double' aria-hidden='true' />
        <nav className='home-index'>
          {entries.map((entry) => (
            <button
              key={entry.key}
              type='button'
              className='home-entry'
              onClick={() => navigate(entry.path)}
            >
              <span className='home-entry-text'>
                <span className='home-entry-head'>
                  <span className='home-entry-title'>{entry.title}</span>
                  {entry.hint && <span className='home-entry-hint'>{entry.hint}</span>}
                </span>
                <span className='home-entry-blurb'>{entry.blurb}</span>
              </span>
              <span className='home-entry-arrow' aria-hidden='true'>→</span>
            </button>
          ))}
        </nav>
      </main>
    </div>
  );
}

export default HomePage;
